import { Popover, PopoverContent, PopoverTrigger } from "Components/ui/popover";
import { Separator } from "Components/ui/separator";
import { ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";

function DropDown({
  title,
  data,
  selected,
  setSelected,
  withImages,
  withLabel,
  classNames,
  justify,
  noArrow,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!selected && data?.length > 0) setSelected(data[0]);
    else setSelected(data?.find((item) => item?.value === selected));
  }, []);

  return (
    <Popover
      open={open}
      onOpenChange={() => {
        !noArrow && setOpen(!open);
      }}
    >
      <PopoverTrigger
        className={`${
          noArrow ? "cursor-default" : "cursor-pointer"
        } bg-background-secondary px-4  py-2 rounded-xl font-N_Roman flex flex-row gap-4 items-center ${classNames}`}
      >
        {title && (
          <>
            <div className="flex items-center gap-2 text-white opacity-[0.7] text-base">
              {title}
            </div>
            <Separator
              orientation="vertical"
              className="w-[0.15rem] h-6 rounded-xl bg-border-darkNew"
            />
          </>
        )}
        <div
          className={`flex items-center gap-2 text-white ${
            justify && "justify-between w-full"
          }`}
        >
          {!withImages ? (
            <div className="flex items-center gap-2 text-white opacity-[0.7] text-base text-nowrap">
              {selected?.label}
            </div>
          ) : withLabel ? (
            <div className="flex items-center gap-2">
              <img
                src={selected?.img}
                alt={selected?.label}
                className="w-auto h-6"
              />
              <div className="text-white opacity-[0.7] text-base text-nowrap">
                {selected?.label}
              </div>
            </div>
          ) : (
            <img
              src={selected?.img}
              alt={selected?.label}
              className="w-auto h-6"
            />
          )}
          {!noArrow && (
            <div className="opacity-[0.7]">
              <ChevronDown size={"1.2rem"} />
            </div>
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent className="border-none bg-background-secondary rounded-[13px] p-2">
        <div className="flex flex-col gap-2 text-base">
          {data?.map((item, index) => (
            <div
              key={index}
              className={`${
                selected === item?.value &&
                "opacity-[0.7] bg-primary-opacity hover:opacity-100"
              } opacity-[0.7] hover:opacity-100 cursor-pointer hover:bg-white-opacity p-2 rounded-lg`}
              onClick={() => {
                setSelected(item);
                setOpen(false);
              }}
            >
              {item?.label}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default DropDown;
